module.exports = __webpack_public_path__ + "img/more.5e7a56cb.svg";